<script setup>
import { ref } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

defineProps([
    'label',
    'id',
    'placeholder',
    'selectText',
    'cancelText',
    'required',
    'name'
])

const date = ref(null)
</script>

<template>
    <div class="input-holder">
        <label :for="id">{{ label }}</label>
        <VueDatePicker v-model="date"
                       :name="name"
                       text-input
                       :placeholder="placeholder"
                       :enable-time-picker="false"
                       :select-text="selectText"
                       :cancel-text="cancelText"
                       :required="required"
                       locale="sk"
        >
            <template #input-icon>
                <img class="input-slot-image" src="/img/icons/calendar.svg"/>
            </template>
        </VueDatePicker>
    </div>
</template>
